import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
,  standalone: false
})
export class TableComponent implements OnInit {


  ngOnInit() {
    //This blank function is mandatory.
  }

}
